import { IconAlertCircle } from '@tabler/icons-react';

const ErrorPage = () => {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100 bg-light text-center px-4">
      <div
        className="bg-white p-4 p-md-5 rounded shadow-lg w-100"
        style={{ maxWidth: '400px' }}
      >
        <IconAlertCircle size={48} className="text-danger mb-3" />
        <h2 className="fw-bold text-dark">Invalid Subscription Plan</h2>
        <p className="text-muted">
          The selected subscription plan is invalid or does not exist. Please
          choose a valid plan to continue.
        </p>
        {/* <button
          className="btn btn-primary mt-3 px-4"
          onClick={() => navigate('/choose-plan')}
        >
          Choose a Plan
        </button> */}
      </div>
    </div>
  );
};

export default ErrorPage;
